const ADDRESS_MODEL_CLASS_NAME = 'Address'

const ADDRESS_MODEL_KEY = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE: 'phone',
  LINE_1: 'line1',
  LINE_2: 'line2',
  POSTAL_CODE: 'postalCode',
  CITY: 'city',
  COUNTRY: 'country',
  STATE: 'state'
}

/**
 * The required attributes.
 * @type {Object}
 */
const ADDRESS_MODEL_KEYS_REQUIRED = [
  ADDRESS_MODEL_KEY.FIRST_NAME,
  ADDRESS_MODEL_KEY.LAST_NAME,
  ADDRESS_MODEL_KEY.EMAIL,
  ADDRESS_MODEL_KEY.COUNTRY,
  ADDRESS_MODEL_KEY.POSTAL_CODE,
  ADDRESS_MODEL_KEY.STATE,
  ADDRESS_MODEL_KEY.CITY,
  ADDRESS_MODEL_KEY.LINE_1
]
const ADDRESS_MODEL_KEY_LABEL = {
  [ADDRESS_MODEL_KEY.FIRST_NAME]: 'First Name',
  [ADDRESS_MODEL_KEY.LAST_NAME]: 'Last Name',
  [ADDRESS_MODEL_KEY.EMAIL]: 'Email',
  [ADDRESS_MODEL_KEY.COUNTRY]: 'Country',
  [ADDRESS_MODEL_KEY.POSTAL_CODE]: 'Postal Code / Zip',
  [ADDRESS_MODEL_KEY.STATE]: 'State / Province / Region',
  [ADDRESS_MODEL_KEY.CITY]: 'City',
  [ADDRESS_MODEL_KEY.LINE_1]: 'Address Line 1',
  [ADDRESS_MODEL_KEY.LINE_2]: 'Address Line 2',
  [ADDRESS_MODEL_KEY.PHONE]: 'Phone'
}

export const ADDRESS_MODEL_KEY_LABEL_KEYS = Object.keys(ADDRESS_MODEL_KEY_LABEL)

const ADDRESS_MODEL_KEYS_SHIPPING = [
  ADDRESS_MODEL_KEY.COUNTRY,
  ADDRESS_MODEL_KEY.POSTAL_CODE
]
const ADDRESS_MODEL_VALIDATOR = {
  // Billing Data
  [ADDRESS_MODEL_KEY.FIRST_NAME]: [
    2,
    30
  ],
  [ADDRESS_MODEL_KEY.LAST_NAME]: [
    2,
    30
  ],
  [ADDRESS_MODEL_KEY.POSTAL_CODE]: [
    4,
    20
  ],
  [ADDRESS_MODEL_KEY.LINE_1]: [
    5,
    255
  ],
  [ADDRESS_MODEL_KEY.CITY]: [
    2,
    60
  ],
  [ADDRESS_MODEL_KEY.STATE]: [
    2,
    30
  ],
  [ADDRESS_MODEL_KEY.PHONE]: [
    8,
    20
  ]
}

export {
  ADDRESS_MODEL_CLASS_NAME,
  ADDRESS_MODEL_KEY,
  ADDRESS_MODEL_KEYS_REQUIRED,
  ADDRESS_MODEL_KEY_LABEL,
  ADDRESS_MODEL_KEYS_SHIPPING,
  ADDRESS_MODEL_VALIDATOR
}
